/**
 * Les accès au stockage du navigateur, qui ne lèvent jamais.
 *
 * Le stockage peut être indisponible — navigation privée verrouillée, site bloqué, quota atteint —
 * et une lecture y lève au lieu de rendre `null`. Une connexion, et surtout une **déconnexion**, ne
 * doivent pas tomber sur une exception de stockage : mieux vaut effacer ce qu'on peut que de
 * s'arrêter au premier refus.
 *
 * Extrait d'`OAuthSessionService` pour être partagé avec `AuthService`, qui efface désormais les deux
 * clés. Deux implémentations de la même prudence, ce serait une de trop.
 */
export function safeRead(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeWrite(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignoré volontairement
  }
}

export function safeRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignoré volontairement
  }
}
